import {
  hasNewAssetGraphNodes,
  type AssetGraphResponseDto,
} from '@terra/shared-contracts-external-network';

export type GraphNodeExpansion = 'checking' | 'available' | 'none';

export const resolveGraphNodeExpansion = ({
  graph,
  neighborhood,
  isPending,
}: {
  graph: AssetGraphResponseDto | null | undefined;
  neighborhood: AssetGraphResponseDto | undefined;
  isPending: boolean;
}): GraphNodeExpansion => {
  if (isPending) {
    return 'checking';
  }

  if (!graph || !neighborhood) {
    return 'available';
  }

  return hasNewAssetGraphNodes({ base: graph, incoming: neighborhood })
    ? 'available'
    : 'none';
};
